<template>
  <svg
    :width="size"
    :height="size"
    :viewBox="`0 0 36 36`"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    preserveAspectRatio="xMinYMin"
  >
    <title :id="'icon-' + id" v-if="id">{{ id }}</title>
    <use :xlink:href="'#img-' + id"></use>
  </svg>
</template>

<script>
let spriteAdded = false

/**
 * This component renders the icon (from svg sprite) coresponding to passed prop - id
 */
export default {
  name: 'SvgSpriteIcon',
  props: {
    size: {
      type: [Number, String],
      default: 36
    },
    id: String
  },
  mounted() {
    if (!spriteAdded) {
      spriteAdded = true
      import(/* webpackChunkName: "icons-sprite" */ '!!raw-loader!@/assets/icons-sprite.svg').then(
        icons => {
          const iconsSprite = document.createElement('div')
          iconsSprite.innerHTML = icons.default
          document.body.appendChild(iconsSprite)
        }
      )
    }
  }
}
</script>
